<template>
  <div>
    <div v-show="listing" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Transactions"
                bc1="App"
                bc2="Transactions"
                bc3="List"
            ></Breadcrumb>
          </div>
          <div
              class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >
          </div>
        </div>
        <div class="content-body" >
          <!-- users list start -->
          <section class="app-user-list" >
            <div class="accordion" id="searchFilterAccordion" v-if="showAllFilters">
              <div class="card">
                <div class="card-header" id="searchFilterHeading">
                  <h5 class="mb-0">
                    <button
                        class="btn btn-link text-primary"
                        type="button"
                        @click="toggleAccordion"
                    >
                      Search Filters
                      <i class="ml-25 fas fa-chevron-down"></i>
                    </button>
                  </h5>
                </div>
                <div
                    id="searchFilterCollapse"
                    aria-labelledby="searchFilterHeading"
                    :class="accordionOpen ? 'show' : 'collapse'"
                >
                  <div class="card-body">
                    <div class="d-flex  align-items-center mx-50 row pt-0 ">
                      <div class="col-md-6 user_role" >
                        <SelectOptions
                            label=""
                            selectAppend="transaction type"
                            labelValue="name"
                            :modelValue.sync="selectedType"
                            :url="showSelectTypesOption"
                        />
                      </div>
                      <div class="col-md-6 user_plan">
                        <SelectOptions
                            label=""
                            selectAppend="currency"
                            labelValue="code"
                            :filter="{ flag: 'active' }"
                            :modelValue.sync="selectedAccount"
                            :url="showSelectAccountOption"
                        />
                      </div>
                      <div class="col-md-6 user_status">
                        <label></label>
                        <div class="form-group">
                          <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here... (Deep search can take longer)"/>
                        </div>
                      </div>

                      <div class="col-md-6 user_status">
                        <label></label>
                        <div class="form-group">
                          <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="searchByUUID" placeholder="Search UUID/ RRN / Gateway Reference"/>
                        </div>
                      </div>

                    </div>
                    <div class="d-flex  align-items-center mx-50 row pt-0 ">
                      <div class="col-md-6 user_role" >
                        <SelectOptions
                            label=""
                            selectAppend="Payment Method"
                            labelValue="name"
                            :filter="{flag: 'active'}"
                            :modelValue.sync="selectedPaymentMethod"
                            url="v1/get-payment-method"
                        />
                      </div>
                      <div class="col-md-6 user_status">
                        <div class="form-group">
                          <label></label>
                          <input class="form-control" type="text" v-model="countryCode" placeholder="Country Code"/>
                        </div>
                      </div>

                    </div>
                    <div class="d-flex  align-items-center mx-50 row pt-1 ">
                      <div class="col-md-6 mb-1 user_plan">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="">
                              <label></label>
                              <SearchSelect
                                  v-model="selectedSchema"
                                  url="v1/get-schema"
                                  :filterParams="{ status: 'active' }"
                                  :customLabelFn="customSchemaNameForMultiselect"
                                  placeholder="Search Schema..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-1 user_plan">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="">
                              <label></label>
                              <SearchSelect
                                  v-model="selectedStore"
                                  url="v1/get-store"
                                  :filterParams="{ status: 1 }"
                                  :customLabelFn="customStoreNameForMultiselect"
                                  placeholder="Search Store..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 user_plan">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="input-group">
                              <label></label>
                              <multiselect
                                  v-model="selectedTerminal"
                                  :options="terminalData"
                                  label="label"
                                  track-by="id"
                                  placeholder="Select Terminal"
                                  :loading="terminalLoader"
                                  variant="primary"
                                  :custom-label="customStoreNameForMultiselect"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 user_plan">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="input-group">
                              <label></label>
                              <multiselect
                                  v-model="selectedChannel"
                                  :options="channelData"
                                  label="label"
                                  track-by="id"
                                  placeholder="Select Channel"
                                  :loading="channelLoader"
                                  variant="primary"
                                  :custom-label="customStoreNameForMultiselect"
                              ></multiselect>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex  align-items-center mx-50 row  ">
                      <div class="col-md-6 mb-1  user_plan">
                        <div class="form-group row">
                          <div class="col-sm-12">
                            <div class="">
                              <label></label>
                              <SearchSelect
                                  v-model="selectedMerchant"
                                  url="v1/get-merchants"
                                  :filterParams="{ flag: 'all' }"
                                  :customLabelFn="customNameForMultiselect"
                                  placeholder="Search Merchant..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-1 user_plan">
                        <SelectOptions
                            label=""
                            selectAppend="Acquirings"
                            labelValue="name"
                            :filter="{ status: 'active' }"
                            :modelValue.sync="selectedAcquiring"
                            url="v1/get-aquiring"
                        />
                      </div>
                    </div>
                    <div class="d-flex  align-items-center mx-50 row pt-0 ">
                      <div class="col-md-4 user_status">
                        <label></label>
                        <date-picker
                            v-model="fromDate"
                            :disabledDate="disableFutureDates"
                            valueType="format"
                            :lang="lang"
                            name="fromDate"
                            placeholder="choose start date"
                        ></date-picker>
                      </div>
                      <div class="col-md-4 user_status">
                        <label></label>
                        <date-picker
                            v-model="toDate"
                            :disabledDate="disableFutureDates"
                            valueType="format"
                            :lang="lang"
                            name="toDate"
                            placeholder="choose end date"
                        ></date-picker>
                      </div>
                    </div>
                    <div class="col-12 d-flex mb-1  justify-content-center mt-1" v-if="filterLoader">
                      <div class="spinner-border text-primary mt-1 mb-1"></div>
                    </div>
                    <div class="d-flex  justify-content-end mx-50 row pt-0 pb-2" v-if="!filterLoader">
                      <div class="col-md-12 user_status d-flex  justify-content-end mt-1 mb-1">
                        <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                        <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
                      </div>
                    </div>
                    <div class="d-flex  justify-content-end mx-50 row pt-0 pb-2" v-if="!filterLoader">
                      <div class="col-md-12 user_status d-flex  justify-content-end  mb-1">
                        <button   type="button" class="btn-sm btn btn-gradient-info ml-1" @click="openJsonExportModal">
                          <feather type="file-text"></feather
                          >
                          Export JSON
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex mb-1  justify-content-center mt-1" v-else>
                <div class="spinner-border text-primary mt-1 mb-1"></div>
              </div>
            <div class="card">
              <div>
                <ul class="nav nav-tabs m-1" role="tablist">
                  <li class="nav-item"  @click="tabToShow = 1">
                    <a class="nav-link" :class="tabToShow == 1 ? 'active' : ''" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Transaction</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 2">
                    <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="false">Gateway Pending</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 3">
                    <a class="nav-link" :class="tabToShow == 3 ? 'active' : ''" id="failure-tab" data-toggle="tab" href="#failure" aria-controls="profile" role="tab" aria-selected="false">Gateway Failure</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 5">
                    <a class="nav-link" :class="tabToShow == 5 ? 'active' : ''" id="preauth-tab" data-toggle="tab" href="#preauth" aria-controls="profile" role="tab" aria-selected="false">Pre-Auth Transactions</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 4">
                    <a class="nav-link" :class="tabToShow == 4 ? 'active' : ''" id="transafer-tab" data-toggle="tab" href="#transfer" aria-controls="profile" role="tab" aria-selected="false">Transfer Pending</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane" :class="tabToShow == 1 ? 'active' : ''" id="home" aria-labelledby="home-tab" role="tabpanel">
                    <NormalTransaction v-if="tabToShow == 1" :filter="filteredData" @exportData="exportData" @getRowData="getRowData" @dataFetched="dataFetched" @getGatewayRowData="getGatewayRowData" />
                  </div>
                  <div class="tab-pane" :class="tabToShow == 2 ? 'active' : ''" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                    <GatewayPendingTransaction v-if="tabToShow == 2" :filter="filteredDataPending" @exportData="exportData" @getRowData="getRowData" @dataFetched="dataFetched" @getGatewayRowData="getGatewayRowData" />
                  </div>
                  <div class="tab-pane" :class="tabToShow == 3 ? 'active' : ''" id="failure" aria-labelledby="failure-tab" role="tabpanel">
                    <GatewayFailureTransaction v-if="tabToShow == 3" :filter="filteredDataFailed" @exportData="exportData" @getRowData="getRowData" @dataFetched="dataFetched" @getGatewayRowData="getGatewayRowData" />
                  </div>
                  <div class="tab-pane" :class="tabToShow == 5 ? 'active' : ''" id="preauth" aria-labelledby="preauth-tab" role="tabpanel">
                    <PreAuthTransaction v-if="tabToShow == 5" :filter="filteredDataPreAuth" @exportData="exportData" @getRowData="getRowData" @dataFetched="dataFetched" @getGatewayRowData="getGatewayRowData" />
                  </div>
                  <div class="tab-pane" :class="tabToShow == 4 ? 'active' : ''" id="transfer" aria-labelledby="failure-tab" role="tabpanel">
                    <TransferPendingTransaction v-if="tabToShow == 4" :filter="filteredDataTransfer" @exportData="exportData" @getRowData="getRowData" @dataFetched="dataFetched" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- users list ends -->

        </div>
      </div>
    </div>
<!--    <TransactionDetails :rowData="rowData" v-if="!listing && (tabToShow != 4) && !gateway" @backFromDetailPage="backFromDetailPage" />-->
<!--    <GatewayPendingOrFailureDetails :rowData="rowData" v-if="!listing  && (tabToShow == 2) && !gateway" @backFromDetailPage="backFromDetailPage" />-->
<!--    <GatewayPendingOrFailureDetails :rowData="rowData" v-if="!listing  && (tabToShow == 3) && !gateway" @backFromDetailPage="backFromDetailPage" />-->
    <GatewayDetails :rowData="rowData" v-if="!listing  && (tabToShow != 4) && gateway" @backFromDetailPage="backFromDetailPage" />
    <TransactionDetailsFromExternal :embedded="true" v-if="showTransactionDetails" />
    <!-- Custom JSON export confirmation modal -->
    <ExportJsonModal
        :show="showJsonExportModal"
        title="Export JSON"
        message="Are you sure to export this?"
        confirmBtnText="Confirm"
        @hide="showJsonExportModal = false"
        @confirmExport="handleJsonExportConfirm"
    />
  </div>

</template>

<script>
import NormalTransaction from "@/pages/dashboard/transactions/NormalTransaction";
import GatewayPendingTransaction from "@/pages/dashboard/transactions/GatewayPendingTransaction";
import GatewayPendingOrFailureDetails from "@/pages/dashboard/transactions/GatewayPendingOrFailureDetails";
import GatewayFailureTransaction from "@/pages/dashboard/transactions/GatewayFailureTransaction";
import TransferPendingTransaction  from "@/pages/dashboard/transactions/TransferPendingTransaction";
import GatewayDetails  from "@/pages/dashboard/transactions/GatewayDetails";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {mapState} from "vuex";
import TransactionDetailsFromExternal from "@/pages/dashboard/transactions/TransactionDetailsFromExternal.vue";
import SearchSelect from "@/components/common/SearchSelect.vue";
import PreAuthTransaction from "@/pages/dashboard/transactions/PreAuthTransaction.vue";
import ExportJsonModal from "@/components/common/ExportJsonModal.vue";

export default {
  props: ['propFilters'],
  components:{
    ExportJsonModal,
    PreAuthTransaction,
    SearchSelect,
    TransactionDetailsFromExternal,
    GatewayDetails,NormalTransaction,GatewayPendingTransaction,GatewayPendingOrFailureDetails,GatewayFailureTransaction,TransferPendingTransaction, DatePicker},
  computed:{
    ...mapState(['showTransactionDetails']),
  },
  beforeMount(){
    if(typeof(this.propFilters) != 'undefined'){
      this.showAllFilters = true
    }
  },
  beforeDestroy() {
    // Reset the transaction details state when component unmounts
    this.$store.dispatch('triggerShowTransactionDetails', false)
  },
  mounted() {
    var tabShow = 1
    if(typeof(this.$route.query.tab) != 'undefined'){
      tabShow = this.$route.query.tab
    }
    else{
      tabShow = 1
    }

    this.showSelectAccountOption = 'v1/get-currency'
    this.showSelectTypesOption = 'v1/transaction-types'

    if(this.showAllFilters){
      this.getStoreData()
    }
   
    

    if(typeof(this.propFilters) != 'undefined'){

      
      let filterData = {}

      if(this.propFilters.currentPage){
        filterData.page = this.propFilters.currentPage
      }

      if(this.propFilters.selectedPaymentMethod){
        this.selectedPaymentMethod = this.propFilters.selectedPaymentMethod
        filterData.paymentMethodId = this.selectedPaymentMethod.id
      }

      if(this.propFilters.selectedSchema){
        this.selectedSchema = this.propFilters.selectedSchema
        filterData.schemaId = this.selectedSchema.id
      }

      if(this.propFilters.selectedAcquiring){
        this.selectedAcquiring = this.propFilters.selectedAcquiring
        filterData.aquiringId = this.selectedAcquiring.id
      }

      if(this.propFilters.countryCode){
        this.countryCode = this.propFilters.countryCode
        filterData.countryCode = this.countryCode
      }


      if(this.propFilters.selectedStore){
        this.selectedStore = this.propFilters.selectedStore
        filterData.storeId = this.selectedStore.id
      }

      if(this.propFilters.selectedTerminal){
        this.selectedTerminal = this.propFilters.selectedTerminal
        filterData.terminalId = this.selectedTerminal.id
      }

      if(this.propFilters.selectedChannel){
        this.selectedChannel = this.propFilters.selectedChannel
        filterData.channelId = this.selectedChannel.id
      }

      if(this.propFilters.selectedType){
        this.selectedType = this.propFilters.selectedType
        filterData.transactionTypeId = this.selectedType.id
      }


      if(this.propFilters.transactionId){
        this.search = this.propFilters.transactionId
        filterData.transactionId = this.search
      }

      if(this.propFilters.transactionUuid){
        this.searchByUUID = this.propFilters.transactionUuid
        filterData.transactionUuid = this.searchByUUID
      }

      if(this.propFilters.toDate){
        this.toDate = this.propFilters.toDate
        filterData.toDate = this.toDate
      }


      if(this.propFilters.fromDate){
        this.fromDate = this.propFilters.fromDate
        filterData.fromDate = this.fromDate
      }

      if(this.propFilters.selectedAccount){
        this.selectedAccount = this.propFilters.selectedAccount
        filterData.selectedAccount = this.selectedAccount
        filterData.currencyId = this.selectedAccount.id
      }

      if(this.propFilters.tabToShow){
        tabShow = this.propFilters.tabToShow
      }

      if(tabShow == 1){
        filterData.tabToShow = 1
        setTimeout(()=>{
          this.filteredData = filterData
        },1000)


      }else if(tabShow == 2){
        filterData.tabToShow = 2
        setTimeout(()=>{
          this.filteredDataPending = filterData
        },1000)
      }else if(tabShow == 3){
        filterData.tabToShow = 3
        setTimeout(()=>{
          this.filteredDataFailed = filterData
        },1000)
      }
      else if(tabShow == 5){
        filterData.tabToShow = 5
        setTimeout(()=>{
          this.filteredDataPreAuth = filterData
        },1000)
      }
      else{
        filterData.tabToShow = 4
        setTimeout(()=>{
          this.filteredDataTransfer = filterData
        },1000)
      }


    }

    


      this.tabToShow = tabShow


  },
  data() {
    return {
      showJsonExportModal: false,
      accordionOpen: false,
      filterLoader:true,
      showAllFilters:false,
      gateway:false,
      listing:true,
      rowData:[],
      tabToShow: 0,
      tab2sendCall: false,
      tab3sendCall: false,
      search: '',
      searchByUUID: '',
      countryCode: '',
      fromDate: null,
      toDate: null,
      selectedAccount: null,
      selectedType: null,
      selectedPaymentMethod: null,
      selectedSchema: null,
      isLoadingSchema: false,
      schemaData: [],
      selectedAcquiring: null,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      filteredData: {},
      filteredDataPending: {},
      filteredDataFailed: {},
      filteredDataTransfer: {},
      filteredDataPreAuth: {},
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      isLoadingStores: false,
      searchQuery: '',
      searchTimeout: null,
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,

    }
  },
  methods: {
    customNameForMultiselect({ email, first_name, business_name }) {
      const nameToUse = business_name === null || business_name === '' ? first_name : business_name;
      return `${email}/${nameToUse}`;
    },
    openJsonExportModal() {
      this.showJsonExportModal = true;
    },

    async handleJsonExportConfirm(syncToTms) {
      this.$store.dispatch('exportExcelLoader', true)
      const requestData = this.buildExportRequestData();
      requestData.jsonData = 1;

      if (syncToTms) {
        requestData.exportAs = 'syncTms';
      }else{
        requestData.exportAs = 'json';
      }

      const response = await this.makeRequest('post', 'v1/export-transactions-json', requestData, {}, true);
      this.$store.dispatch('exportExcelLoader', false)
      // if (!response.error && response.response.data.code === 200) {
      //   const url = response.response.data.data.url;
      //   if (url) window.open(url, '_blank');
      // }

      this.showJsonExportModal = false;
    },

    // Extract from existing exportData to avoid duplication
    buildExportRequestData() {
      let requestData = {
        reportType: 'transaction',
      };

      if (this.selectedPaymentMethod) requestData.paymentMethodId = this.selectedPaymentMethod.id;
      if (this.selectedSchema) requestData.schemaId = this.selectedSchema.id;
      if (this.selectedAcquiring) requestData.aquiringId = this.selectedAcquiring.id;
      if (this.countryCode) requestData.countryCode = this.countryCode;
      if (this.selectedStore) requestData.storeId = this.selectedStore.id;
      if (this.selectedMerchant) requestData.recUserId = this.selectedMerchant.id;
      if (this.selectedTerminal) requestData.terminalId = this.selectedTerminal.id;
      if (this.selectedChannel) requestData.channelId = this.selectedChannel.id;
      if (this.selectedType) requestData.transactionTypeId = this.selectedType.id;
      if (this.selectedAccount) requestData.currencyId = this.selectedAccount.id;
      if (this.search) requestData.transactionId = this.search;
      if (this.searchByUUID) requestData.transactionUuid = this.searchByUUID;
      if (this.toDate) requestData.toDate = this.toDate;
      if (this.fromDate) requestData.fromDate = this.fromDate;
      requestData.page = this.$store.getters.getChosenPage;

      // Tab-specific status
      if (this.tabToShow === 1) requestData.status = 1;
      else if (this.tabToShow === 2) requestData.status = 0;
      else if (this.tabToShow === 3) requestData.status = 2;
      else if (this.tabToShow === 5) requestData.status = 3;
      else requestData.status = 3; // transfer pending

      return requestData;
    },
    exportData(exportType){
      let requestData = {
        exportAs: exportType,
        reportType: 'transaction',
        // startDate: this.fromDate,
        // endDate:this.toDate,
        // transaction_type_id:this.selectedType?this.selectedType.id:'',
        // search:this.search,

      }

      if(this.selectedPaymentMethod){
        requestData.paymentMethodId = this.selectedPaymentMethod.id
      }

      if(this.selectedSchema){
        requestData.schemaId = this.selectedSchema.id
      }

      if(this.selectedAcquiring){
        requestData.aquiringId = this.selectedAcquiring.id
      }

      if(this.countryCode != ''){
        requestData.countryCode = this.countryCode
      }

      if(this.selectedStore){
        requestData.storeId = this.selectedStore.id
      }

      if(this.selectedMerchant){
        requestData.recUserId = this.selectedMerchant.id
      }

      if(this.selectedTerminal){
        requestData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        requestData.channelId = this.selectedChannel.id
      }
      if(this.selectedType){
        requestData.transactionTypeId = this.selectedType.id
      }
      if(this.selectedAccount){
        requestData.currencyId = this.selectedAccount.id
      }
      if(this.search != ''){
        requestData.transactionId = this.search
      }
      if(this.searchByUUID != ''){
        requestData.transactionUuid = this.searchByUUID
      }
      if(this.toDate){
        requestData.toDate = this.toDate
      }
      if(this.fromDate){
        requestData.fromDate = this.fromDate
      }

      if(this.tabToShow == 1){
        /*norma;*/
        requestData.status = 1
      }else if(this.tabToShow == 2){
        /*gateway pending*/
        requestData.status = 0
      }else if(this.tabToShow == 3){
        /*gateway failure*/
        requestData.status = 2
      }else if(this.tabToShow == 5){
        /*Pre-Auth*/
        requestData.status = 3
      }
      else{
        /*transfer pending*/
        requestData.status = 3
      }

      this.downloadReport(requestData)

    },
    dataFetched(){
      this.getStoreData()
      this.filterLoader = false
      this.showAllFilters = true
     
    },
    getRowData(row){
      this.rowData = row
      this.listing = false
    },
    getGatewayRowData(row){
      this.rowData = row
      this.listing = false
      this.gateway = true
    },
    backFromDetailPage(){
      this.gateway = false
      /*close accordian*/
      var elems = document.querySelectorAll(".collapse");

      [].forEach.call(elems, function(el) {
        el.classList.remove("show");
      });
      this.listing = true
    },
    triggerChangeTab(val){
      this.tabToShow = val
    },
    onSubmitFilters() {
       this.filterLoader = true
       let filterData = {}

      if(this.selectedPaymentMethod){
        filterData.selectedPaymentMethod = this.selectedPaymentMethod
        filterData.paymentMethodId = this.selectedPaymentMethod.id
      }

      if(this.selectedSchema){
        filterData.selectedSchema = this.selectedSchema
        filterData.schemaId = this.selectedSchema.id
      }

      if(this.selectedAcquiring){
        filterData.selectedAcquiring = this.selectedAcquiring
        filterData.aquiringId = this.selectedAcquiring.id
      }

      if(this.countryCode != ''){
        filterData.countryCode = this.countryCode
      }

      if(this.selectedStore){
        filterData.selectedStore = this.selectedStore
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.selectedTerminal = this.selectedTerminal
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.selectedChannel = this.selectedChannel
        filterData.channelId = this.selectedChannel.id
      }

       if(this.selectedType){
         filterData.selectedType = this.selectedType
         filterData.transactionTypeId = this.selectedType.id
       }
      if(this.selectedAccount){
        filterData.selectedAccount = this.selectedAccount
        filterData.currencyId = this.selectedAccount.id
      }
      if(this.search != ''){
        filterData.transactionId = this.search
      }
      if(this.searchByUUID != ''){
        filterData.transactionUuid = this.searchByUUID
      }
      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }

      if(this.selectedMerchant){
        filterData.selectedMerchant = this.selectedMerchant
        filterData.recUserId = this.selectedMerchant.id
      }


      // if(this.tabToShow == 1){
      //   filterData.tabToShow = 1
      //   this.filteredData = filterData
      //
      // }else if(this.tabToShow == 2){
      //   filterData.tabToShow = 2
      //   this.filteredDataPending = filterData
      // }else if(this.tabToShow == 3){
      //   filterData.tabToShow = 3
      //   this.filteredDataFailed = filterData
      // }else{
      //   filterData.tabToShow = 4
      //   this.filteredDataTransfer = filterData
      // }


      this.filteredData = filterData

      this.filteredDataPending = filterData

      this.filteredDataFailed = filterData

      this.filteredDataTransfer = filterData

      this.filteredDataPreAuth = filterData




    },
    clear(){
      this.filterLoader = true
      this.selectedType = null
      this.selectedAccount = null
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.searchByUUID = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedAcquiring = null
      this.selectedSchema = null
      this.selectedPaymentMethod = null
      this.selectedMerchant = null
      this.countryCode = ''
      this.filteredData = {}
      this.filteredDataPending = {}
      this.filteredDataFailed = {}
      this.filteredDataTransfer = {}
      this.filteredDataPreAuth = {}



    },
    getStoreData() {
      if(this.storeData.length > 0){
        return
      }
      this.makeRequest("post", "v1/get-store", {status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.storeData = responseData;
                }
                else{
                  this.storeData = []
                }
                // this.setSelectedStoreValue();
              }
            }
          }
      );
    },
    setSelectedStoreValue() {


      if (this.selectedStore == null && this.storeData.length > 0) {
        this.selectedStore = this.storeData[0];

      }
      else{
        this.selectedStore = null
      }
    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    customSchemaNameForMultiselect (item) {
      return item?.description? item.name + '/' + item.code + ' (' + item.description + ')' : item.name + '/' + item.code
    },
    toggleAccordion() {
      this.accordionOpen = !this.accordionOpen;
    },
  },
  watch: {
    tabToShow(val) {

      this.filterLoader = true
      // this.clear()
      // send call for second and third tabs if tab is clicked, send call if not sent before
      if(val == 2 && !this.tab2sendCall )
        this.tab2sendCall = true;
      else if(val == 3 && !this.tab3sendCall )
        this.tab3sendCall = true;
    },
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
    showTransactionDetails(val) {
      this.listing = !val
    }
  }
}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
</style>

